import { derived } from 'svelte/store';
import { cart } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/stores/cart.js?1733898722547';
import { token } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/stores/token.js?1733898722547';
import { customer } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/stores/customer.js?1733898722547';

function createCheckoutData() {
    return derived([cart, token, customer], ([$cart, $token, $customer], set) => {
        const customer_allowed = !$cart?.guest && $token && $customer && $token === $customer?.token && $customer.email;
        const guest_allowed = $cart?.guest && !$token && !$customer;
        const has_cart = $cart?.items?.length > 0;
        if (!has_cart) {
            set(undefined);
            return;
        }
        if (customer_allowed) {
            set({ email: $customer.email, token: $token, guest: false });
            return;
        }
        if (guest_allowed) {
            set({ cart: $cart.cart_id, id: $cart.id, guest: true });
            return;
        }
        set(undefined);
    });
}

export const checkout_data = createCheckoutData();
